// Module
var code = "<div class=\"c-definitions c-rokuDisplay\">\n    <div class=\"c-definition\">\n        <div class=\"c-definition-term\" ng-bind=\"::$ctrl.localeKeys.E_WALLET.ROKU.USERNAME | i18n\"></div>\n        <div class=\"c-definition-value\" ng-bind=\"$ctrl.detailData.UserName | invEmpty\"></div>\n    </div>\n</div>\n";
// Exports
module.exports = code;